module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1292.94e48881.png";